import React from 'react';

import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = (props ) => {
    
    const linksOutput = props.links.map(oneNavLink => {
     
        return <NavigationItem key={oneNavLink.term_id} 
                               link={oneNavLink.slug} 
                               clicked={props.actionClicked} 
                               toggleAction={props.toggleAction}
                               >
                                    {oneNavLink.name}
                </NavigationItem>;
    });

    return(
        <ul className="nav-items">
             {linksOutput} 
        </ul>
    );
}

export default navigationItems;


// WEBPACK FOOTER //
// ./src/containers/Navigation/NavigationsItems/NavigationItems.js